export var FILE_EXTENSIONS;
(function (FILE_EXTENSIONS) {
    FILE_EXTENSIONS["DOC"] = "doc";
    FILE_EXTENSIONS["DOCX"] = "docx";
    FILE_EXTENSIONS["DWFX"] = "dwfx";
    FILE_EXTENSIONS["IFC"] = "ifc";
    FILE_EXTENSIONS["JPEG"] = "jpeg";
    FILE_EXTENSIONS["JPG"] = "jpg";
    FILE_EXTENSIONS["NWD"] = "nwd";
    FILE_EXTENSIONS["PDF"] = "pdf";
    FILE_EXTENSIONS["PNG"] = "png";
    FILE_EXTENSIONS["PPTX"] = "pptx";
    FILE_EXTENSIONS["RVT"] = "rvt";
    FILE_EXTENSIONS["XLS"] = "xls";
    FILE_EXTENSIONS["XLSX"] = "xlsx";
})(FILE_EXTENSIONS || (FILE_EXTENSIONS = {}));
export var MIME_TYPES;
(function (MIME_TYPES) {
    MIME_TYPES["CSV"] = "text/csv";
    MIME_TYPES["GIF"] = "image/gif";
    MIME_TYPES["JPEG"] = "image/jpeg";
    MIME_TYPES["PNG"] = "image/png";
    MIME_TYPES["SVG"] = "image/svg";
    MIME_TYPES["PDF"] = "application/pdf";
})(MIME_TYPES || (MIME_TYPES = {}));
//# sourceMappingURL=FileExtensions.js.map